/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AddClientForm from './AddESPForm';
import OutlineButton from '../../MUICustomButton/OutlineButton';
import { useNavigate } from 'react-router-dom';

export interface PropsType {
    parentId?: string;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps): JSX.Element {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

function AddClientTabs({parentId}: PropsType): JSX.Element {
    const [value, setValue] = React.useState(0);

    const navigate = useNavigate()

    const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
        setValue(newValue);

    };

    const handleBackClick = (): void => {
        navigate('/email-api')
    }

    return (
        <>
            <div className="flex justify-between items-center mb-[20px]">
                <div>
                    <h2 className="text-2xl font-semibold text-title ">Client Configuration</h2>
                </div>
                <div>
                    <OutlineButton onClick={handleBackClick} type='rounded' color='red' width='200px'>
                        <img src="/assets/images/red-arrow.svg" alt="arrow" width={9} height={8} className="mr-[5px] mt-[1px]" />
                        Manage ESP Settings
                    </OutlineButton>
                </div>
            </div>

            <div className='tab-container'>
                <Box
                    sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', borderRadius: '12px' }}
                >
                    <Box sx={{ display: "flex", flexDirection: "column", borderRight: 0.5, borderColor: "#F5F5F5", width: '15%' }}>
                        <Typography variant="h6" gutterBottom sx={{ background: '#F5F5F5', color: '#3A3A3A', fontSize: '16px', fontWeight: '600', padding: '12px 16px', borderTopLeftRadius: '8px', marginBottom: '0px' }}>
                            Add New ESP
                        </Typography>
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={value}
                            onChange={handleChange}
                            aria-label="Vertical tabs example"
                        >
                            <Tab label="Profile" {...a11yProps(0)} />
                            

                        </Tabs>
                    </Box>

                    <TabPanel value={value} index={0}>
                        <AddClientForm parentId={parentId} />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        Item Two
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        Item Three
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        Item Four
                    </TabPanel>

                </Box>
            </div>
        </>
    )
}

export default AddClientTabs